import React from 'react';
import { Modal, ModalBody, ModalFooter } from '@carbon/react';
import useModal from '@/lib/hooks/useModal';

export const NoLocationWarning = ({hideModal}) => {
  const [showLocationWizard] = useModal('LOCATION_WIZARD');

  return (
    <Modal
      open={true}
      danger={false}
      size="sm"
      primaryButtonText="Jetzt Einrichten"
      secondaryButtonText="Abbrechen"
      modalHeading="Du hast noch kein Standort eingerichtet."
      onRequestClose={hideModal}
      onRequestSubmit={() => {
        hideModal();
        showLocationWizard();
      }}>
      <ModalBody>
        <p>
          Um Micast-Systeme Einrichten zu können musst du zunächst mindestens
          einen Standort einrichten.
        </p>
        <br />
        <p>
          Du kannst jetzt direkt loslegen indem du auf "Jetzt Einrichten"
          klickst
        </p>
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
};
